export default {
    methods: {
        resetObject() {
            this.data = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        prepareData(data) {
            return data;
        },
        prepareFormData(data) {
            return {
                participant_correspondence: {
                    participant: data.participant.id,
                    content: data.content,
                    subject: data.subject,
                },
            };
        },
    },
};
